import { FAQ, ProfileItem } from "components/FAQ"
import {
    aboutAlter,
    aboutBooking,
    aboutWorkWithPsychologist,
    ifYouAreNotSure,
} from "components/FAQ/FAQItems"

export function FAQContainer({ className }: { className?: string }) {
    return (
        <div className={className}>
            <FAQ
                renderProp={[
                    aboutWorkWithPsychologist,
                    aboutBooking,
                    ifYouAreNotSure,
                    aboutAlter,
                ].map((faqItem, index) => (
                    <ProfileItem faqItem={faqItem} key={index} />
                ))}
            />
        </div>
    )
}
